import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";

import CircularProgress from "../Circular/Circular";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { format } from "date-fns";
import Button from "components/CustomButtons/Button.js";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ExportCsv from "exportCsv.js";
import DateCus from "components/Date/Date";
const useStyles = makeStyles(styles);

function createData(number, operation, data, user, doc) {
  data = format(new Date(data), "dd/MM/yyyy", {
    timeZone: "America/Sao_Paulo",
  });
  return { number, operation, data, user, doc };
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order ==="desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "number", numeric: true, disablePadding: false, label: "Número" },
  { id: "operation", numeric: false, disablePadding: false, label: "Operação" },
  { id: "data", numeric: false, disablePadding: false, label: "Data" },
  { id: "user", numeric: false, disablePadding: false, label: "Usuário" },
  { id: "doc", numeric: true, disablePadding: false, label: "Documento" },
];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy ===headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy ===headCell.id}
              direction={orderBy ===headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy ===headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order ==="desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

/* const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
})); */

export default function TicketReport() {
  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [circular, setCircular] = React.useState(true);
  const [rps, setRps] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [exp, setExport] = React.useState(false);
  const [openDate, setOpenDate] = React.useState(false);

  const handleClickEl = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickExportCSV = (e) => {
    handleClickEl(e);
    setExport(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    async function getData() {}

    getData();
  }, []);

  function createRows(dataRps) {
    const _rpsData = [];
    let exportData = [];

    dataRps.forEach((el) => {
      const operacao = el.codigoItem ==="5555010001" ? "Entrada" : "Saída";
      let row = createData(
        el.numeroRPS,
        operacao,
        el.data,
        el.customer.name,
        el.customer.documentValue
      );
      exportData.push({
        Número: el.numeroRPS,
        Operação: operacao,
        Data: el.data,
        Usuário: el.customer.name,
        Documento: el.customer.documentValue,
      });
      _rpsData.push(row);
    });
    setRows(_rpsData);

    if (exp && exportData.length > 0) {
      ExportCsv(exportData);
    }
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy ===property && order ==="asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.number);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex ===-1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex ===0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex ===selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  async function handle1Dia() {
    let now = new Date();
    let _rpsData = rps.filter((r) => new Date(r.data) ===now);
    setDataRows(_rpsData);
  }

  async function handle7Dias() {
    let now = new Date();
    now.setDate(now.getDate() - 7);
    let _rpsData = rps.filter((r) => new Date(r.data) >= now);
    setDataRows(_rpsData);
  }

  async function handle1Mes() {
    let now = new Date();
    now.setDate(now.getDate() - 30);
    let _rpsData = rps.filter((r) => new Date(r.data) >= now);
    setDataRows(_rpsData);
  }

  async function handle6Meses() {
    let now = new Date();
    now.setDate(now.getDate() - 180);
    let _rpsData = rps.filter((r) => new Date(r.data) >= now);
    setDataRows(_rpsData);
  }

  async function handle1Ano() {
    let now = new Date();
    now.setDate(now.getDate() - 365);
    let _rpsData = rps.filter((r) => new Date(r.data) >= now);
    setDataRows(_rpsData);
  }

  async function handleAll() {
    let _rpsData = rps;
    setDataRows(_rpsData);
  }

  async function handleCustomaze(dateFrom, dateTo) {
    let _rpsData = rps.filter((r) => {
      if (new Date(r.data) >= dateFrom && new Date(r.data) <= dateTo) {
        return true;
      }
      return false;
    });
    setDataRows(_rpsData);
  }

  const setDataRows = (data) => {
    createRows(data);

    handleClose();
    setExport(false);
  };

  return circular ? (
    <div>
      <CircularProgress />
    </div>
  ) : (
    <div className={classes.root}>
      <Button
        color="primary"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClickEl}
      >
        Filtrar por período
      </Button>
      <Button
        color="default"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClickExportCSV}
      >
        Exportar csv
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleAll}>Todos</MenuItem>
        <MenuItem onClick={handle1Dia}>1 Dia</MenuItem>
        <MenuItem onClick={handle7Dias}>7 Dias</MenuItem>
        <MenuItem onClick={handle1Mes}>1 Mes</MenuItem>
        <MenuItem onClick={handle6Meses}>6 Meses</MenuItem>
        <MenuItem onClick={handle1Ano}>1 Ano</MenuItem>
        <MenuItem onClick={() => setOpenDate(true)}>Customizado</MenuItem>
      </Menu>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.number);
                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.number)}
                      aria-checked={isItemSelected}
                      key={row.number}
                      selected={isItemSelected}
                    >
                      <TableCell align="right">{row.number}</TableCell>
                      <TableCell align="right">{row.operation}</TableCell>
                      <TableCell align="right">{row.data}</TableCell>
                      <TableCell align="right">{row.user}</TableCell>
                      <TableCell align="right">{row.doc}</TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 50, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      {openDate ? (
        <DateCus
          open={openDate}
          onChangeDate={handleCustomaze}
          onChange={() => setOpenDate(false)}
        />
      ) : null}
    </div>
  );
}
